import React from 'react';
import VendorClaimsWidget from '../../components/VendorClaimsWidget';
import { Card, CardContent } from '../../components/ui/card';

export default function VendorClaimsAdminPage() {
  return (
    <div className="space-y-6" data-testid="vendor-claims-admin-page">
      <div>
        <h1 className="text-2xl font-bold text-slate-900 font-['Outfit']">Vendor & Client Onboarding Claims</h1>
        <p className="text-sm text-slate-500 mt-1">
          Each newly introduced vendor / client is "owned" by the recruiter who first added it.
          They earn the staged bonus (Stage 1 + 2-6) over up to 6 placements within a 365-day window.
          Backed-out / rejected placements do <strong>not</strong> count.
        </p>
      </div>

      <Card className="border-amber-200 bg-amber-50/50">
        <CardContent className="p-4 text-xs text-amber-800 grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <p className="font-semibold mb-1">New Vendor</p>
            <p>Stage 1: ₹10,000 · Stages 2-6: ₹7,500 each</p>
            <p className="text-amber-600">Total cap: ₹47,500</p>
          </div>
          <div>
            <p className="font-semibold mb-1">Existing New Vendor (Subsidiary)</p>
            <p>Stage 1: ₹5,000 · Stages 2-6: ₹3,000 each</p>
            <p className="text-amber-600">Total cap: ₹20,000</p>
          </div>
          <div>
            <p className="font-semibold mb-1">New Client (revenue ≥ $2B)</p>
            <p>Stage 1: ₹25,000 · Stages 2-6: ₹15,000 each</p>
            <p className="text-amber-600">Total cap: ₹1,00,000</p>
          </div>
        </CardContent>
      </Card>

      <VendorClaimsWidget title="All Active Onboarding Claims" />
    </div>
  );
}
